import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { API_KEY_MAP } from "../utils/constants";
import { toast } from "react-toastify";

const API_BASE_URL =
  process.env.REACT_APP_ADMIN_API_V1_URL ||
  "https://admin-api.joinpinyada.dev/api/v1";

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {

    console.log("Outgoing Request:", {
      url: config.url,
      method: config.method,
      headers: config.headers,
    });
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const urlPath = new URL(config.url ?? "", window.location.origin).pathname;

    const matchedKey = Object.entries(API_KEY_MAP).find(([path]) =>
      urlPath.startsWith(path)
    );
    console.log("Request URL Path:", urlPath);
    console.log("Matched API Key:", matchedKey);

    if (matchedKey) {
      const [, apiKey] = matchedKey;
      config.headers["Api-Key"] = apiKey;
    } else {
      // fallback default key if needed
      config.headers["Api-Key"] =
        process.env.REACT_APP_ADMINL_GENERAL_API_KEY || "";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (error.response?.data?.code === 401 || error.response?.code === 401) {
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");
      toast.error(
        error.response?.data?.error || "Session expired. Please log in again."
      );
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
